import { store } from "../../../atoms";
import { Theme, themeAtom } from "../../../atoms/theme.atom";

export const isDarkMode = (mode?: Theme) =>
  (mode ?? store.get(themeAtom).mode) === Theme.Dark;
